// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dce241b0","453":"e49395e8","455":"04bcb643"}[chunkId] + ".chunk.js";
};